import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ThreadsSchedulerSettingsFormComponent } from '../threads-scheduler-settings-form/threads-scheduler-settings-form.component';
import * as _ from 'lodash';
import { FormGroup } from '@angular/forms';
import { ISchedulerSettings } from '../../interfaces/scheduler-settings.interface';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'app-threads-scheduler-settings',
    templateUrl: './threads-scheduler-settings.component.html',
    styleUrls: ['./threads-scheduler-settings.component.scss']
})
export class ThreadsSchedulerSettingsComponent implements OnInit {
    @ViewChild(ThreadsSchedulerSettingsFormComponent)
    formComponent: ThreadsSchedulerSettingsFormComponent;

    @Input()
    settings: ISchedulerSettings;

    get formGroup(): FormGroup {
        return _.get(this, 'formComponent.formGroup');
    }

    get isFormInvalid(): boolean {
        return _.get(this.formGroup, 'invalid', false);
    }

    get formValue(): any {
        return _.get(this.formGroup, 'value');
    }

    constructor(private dialogRef: MatDialogRef<ThreadsSchedulerSettingsComponent>) {}

    ngOnInit(): void {}

    save() {
        this.settings.initWithJSON(
            _.pick(this.formGroup.value, [
                'optimalThreadsPerEc2InstanceCount',
                'threadsIncreaseIntervalMin',
                'threadsIncreaseSchedulerActive'
            ]) as any
        );
        this.dialogRef.close(this.settings);
    }
}
